import { render, staticRenderFns } from "./ResultDocsList.vue?vue&type=template&id=56634bbd&scoped=true&"
import script from "./ResultDocsList.vue?vue&type=script&lang=ts&"
export * from "./ResultDocsList.vue?vue&type=script&lang=ts&"
import style0 from "./ResultDocsList.vue?vue&type=style&index=0&id=56634bbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56634bbd",
  null
  
)

export default component.exports